/* eslint-disable camelcase */
import { legacy_createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';

import rootReducer from './reducers';

const initalState = {};

const middleware = [thunk];

// Use Redux DevTools if available (browser extension), otherwise use plain compose
const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = legacy_createStore(
  rootReducer,
  initalState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
